import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../utils';

interface LinkProps {
  children: ReactNode;
  href: string;
  addOnClass?: string;
  openInNewTab?: boolean;
}

/**
 * A React component that renders a navigation link using the `NavLink` component from `react-router-dom`.
 * It applies custom styles to the link and accepts additional classes via the `addOnClass` prop.
 *
 * @param children - The content to be displayed inside the link.
 * @param href - The URL to navigate to when the link is clicked.
 * @param addOnClass - An optional additional class to apply to the link.
 *
 * @returns A React component representing a navigation link.
 */
export default function ({
  children,
  href,
  openInNewTab = false,
  addOnClass = '',
}: LinkProps) {
  return (
    <NavLink
      to={href}
      className={cn(
        'text-xs font-semibold hover:opacity-80 hover:underline transition-colors flex flex-row items-center gap-1.5',
        addOnClass,
      )}
      style={{ color: '#4649EC' }}
      target={openInNewTab ? '_blank' : undefined}
    >
      {children}
    </NavLink>
  );
}
